import './lib/';

window.elements_more_params = {};
import '../css/';
import './css/';
import Element from './components/';

module.exports = {
	Element,
};



// WEBPACK FOOTER //
// ../src4js/pc4mobx/portal/elements/index.js